/**
 * CUSTOM: <floating-badge>
 * Schwebendes Bild (position: fixed). Scroll-GEBUNDEN: faehrt proportional zur Scroll-Position
 * raus (--fb-progress 0..1). Stoppt man das Scrollen, bleibt es an der Stelle; scrollt man zurueck,
 * kommt es zurueck. Der Slide-Bereich = eine Bildschirmhoehe, waehrend die Flow-Position der
 * Section (Sentinel) den Viewport von unten nach oben durchlaeuft. Kein Timing/keine Einstellung.
 */
if (!customElements.get('floating-badge')) {
  class FloatingBadge extends HTMLElement {
    connectedCallback() {
      this.sentinel = this.querySelector('.custom-floating-badge__sentinel');
      this.hideOnPass = this.dataset.hideOnPass === 'true';
      this.posDesktop = parseFloat(this.dataset.pos) || 0;
      this.posMobile = parseFloat(this.dataset.posMobile) || 0;

      if (!this.hideOnPass || !this.sentinel) return;

      this._ticking = false;
      this._onScroll = this._onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._update();
        this._ticking = false;
      });
    }

    _update() {
      const vh = window.innerHeight || 1;
      // Feste Laenge (35% der Bildschirmhoehe). Position verschiebt Start UND Ende zusammen
      // (posPct = wie weit vor der Section-Position es fertig ist -> hoeher = frueher).
      const length = vh * 0.35;
      const posPct = window.innerWidth < 700 ? this.posMobile : this.posDesktop;
      const offset = vh * (posPct / 100);
      const top = this.sentinel.getBoundingClientRect().top;
      let progress = (offset + length - top) / length;
      progress = Math.max(0, Math.min(1, progress));
      this.style.setProperty('--fb-progress', progress.toFixed(4));
    }
  }

  customElements.define('floating-badge', FloatingBadge);
}
